import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Message } from '@meitu/saas-ui';
import { useKeyPressListener } from '@meitu/saas-editor-core/es/framework/operate/hotkey/hooks/use-key-press-listener';
import IconFont from '@meitu/xdesign-icon-font';
import { isEditTagMaterial } from '@/hooks/fetch-template/editor-mode';
import { editor } from '@/instance';
import { useStoreActions, useStoreState } from '@/store';
import { isInternalDesignerMode } from '@/utils/auth';
import { getQueryParam } from '@/utils/query';
import SaveFail from './save-fail';
import SaveSuccess from './save-success';
import saveTemplate from './use-save-template';

const SaveBtn = () => {
    const [disableOperate, setDisableOperate] = useState(false);

    // 是否存草稿
    const draft = useRef(false);
    const [showSaveSuccess, setShowSaveSuccess] = useState(false);
    const [showSaveFail, setShowSaveFail] = useState(false);

    const templateName = useStoreState((state) => state.templateModel.templateName);
    const resolution = useStoreState((state) => state.templateModel.resolution);
    const canvasType = useStoreState((state) => state.templateModel.canvasType);
    const extraInfo = useStoreState((state) => state.templateModel.extraInfo);
    const psdFileUrl = useStoreState((state) => state.templateModel.psdFileUrl);
    const useWatermark = useStoreState((state) => state.templateModel.useWatermark);
    const initTemplateInfo = useStoreActions((actions) => actions.templateModel.initTemplateInfo);
    const markConfig = useStoreState((state) => state.textMarkModel.markConfig);
    const textArtConfig = useStoreState((state) => state.textMarkModel.textArtConfig);

    const [loading, setLoading] = useState<boolean>(false);
    useEffect(() => {
        draft.current = getQueryParam('draft') === '1';
    }, []);

    useEffect(() => {
        // 监听editor状态
        editor.onState(({ disableOperate, disablePick, isBaseOperate }) => {
            setDisableOperate((disableOperate || disablePick) && !isBaseOperate);
        });
    }, []);

    const handlerSave = async (showModal = true, save = true, back = false, successMsg = '保存成功') => {
        try {
            await saveTemplate(
                editor,
                templateName,
                resolution,
                canvasType,
                extraInfo,
                psdFileUrl || '',
                useWatermark,
                setLoading,
                setShowSaveFail,
                setShowSaveSuccess,
                initTemplateInfo,
                showModal,
                save,
                back,
                successMsg,
                editor.font.getList(),
                markConfig,
                textArtConfig,
            );
        } catch (e: any) {
            Message.error(e);
        }
    };

    // 注册保存
    useKeyPressListener(['ctrl+s', 'Command+s'], () => {
        // code
        handlerSave(!draft.current, !draft.current, false, '保存成功');
    });

    if (isEditTagMaterial()) {
        return null;
    }

    return (
        <div
            className={classnames('p-header__save-btn', {
                'p-header__redo-btn--disable': disableOperate,
            })}
            style={{ marginRight: '10px' }}
        >
            {showSaveSuccess && !isInternalDesignerMode() ? (
                <SaveSuccess
                    closeModel={() => {
                        setShowSaveSuccess(false);
                    }}
                />
            ) : null}
            {showSaveFail ? (
                <SaveFail
                    closeModel={() => {
                        setShowSaveFail(false);
                    }}
                />
            ) : null}

            <Button
                type="primary"
                data-blue
                disabled={disableOperate}
                onClick={() => {
                    handlerSave(
                        !draft.current,
                        !draft.current,
                        draft.current,
                        draft.current ? '保存成功，请到任务详情里【提交审核】' : '保存成功',
                    );
                }}
                icon={<IconFont name="CloudSyn" fontSize={20} />}
            >
                保存
            </Button>
        </div>
    );
};

export default React.memo(SaveBtn);
